// Wait for SideDrawer to be available before defining CalendarDrawer
function initializeCalendarDrawer() {
  if (typeof SideDrawer === 'undefined') {
    // SideDrawer not ready yet, wait a bit and try again
    setTimeout(initializeCalendarDrawer, 100);
    return;
  }

class CalendarDrawer extends SideDrawer {
    connectedCallback() {
      this.bindEvents();
      this.initializeWebSocket();
    }
  
    bindEvents() {
      this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
      this.closeDrawerViaEventHandler = this.close.bind(this, null);
      this.calendarButtonClickHandler = this.handleCalendarButtonClick.bind(this);
      
      document.addEventListener(
        "dispatch:calendar-drawer:open",
        this.openDrawerViaEventHandler,
      );
      document.addEventListener(
        "dispatch:calendar-drawer:close",
        this.closeDrawerViaEventHandler,
      );
      document.addEventListener(
        "click",
        this.calendarButtonClickHandler,
      );
      
      this.addEventListener("on:calendar-drawer:before-open", async () => {
        const customerId = window.customerId;
        const shop = window.shopUrl;
        if (!customerId) {
          console.error("Customer ID not found");
          return;
        }
        try {
          const data = await fetchAppProxyData("get_customer_data", {
            customerId: customerId,
            shop: shop,
          });
          console.log("✅ Calendar data loaded successfully from backend:", data);
          this.renderCalendarContent(data);
        } catch (error) {
          console.error("Error loading calendar data:", error);
          this.renderCalendarError();
              }
      });
      
      this.addEventListener("on:calendar-drawer:after-open", () => {
        theme.manuallyLoadImages(this);
      });
    }
    
    handleCalendarButtonClick(event) {
      const calendarLink = event.target.closest(".header-calendar-link");
      if (calendarLink) {
          event.preventDefault();
        console.log("📅 Calendar button clicked, opening drawer...");
          this.open();
      }
    }
  
    disconnectedCallback() {
      document.removeEventListener(
        "dispatch:calendar-drawer:open",
        this.openDrawerViaEventHandler,
      );
      document.removeEventListener(
        "dispatch:calendar-drawer:close",
        this.closeDrawerViaEventHandler,
      );
      document.removeEventListener(
        "click",
        this.calendarButtonClickHandler,
      );
    }
  
    handleDrawerOpenViaEvent(evt) {
      this.open();
    }
  
    async close(opener) {
      this.disconnectWebSocket();
      super.close(opener);
      
      // Sync calendar changes to Seal after closing
      const customerId = window.customerId;
      if (customerId) {
        console.log("📤 Syncing calendar changes to Seal...");
        try {
          await fetchAppProxyData("sync_seal_with_calendar", {
            customerId: customerId
          });
          console.log("✅ Calendar synced to Seal successfully");
        } catch (error) {
          console.error("⚠️ Failed to sync calendar to Seal:", error);
          // Continue closing even if sync fails - changes are saved in Django
        }
      }
    }

    renderCalendarContent(data) {
      const contentItems = this.querySelector(".calendar-drawer__content-items");
      if (!contentItems) return;

      // Hide loader if present
      const loader = this.querySelector('.calendar-loader-container');
      if (loader) loader.style.display = 'none';

      contentItems.innerHTML = "";

      if (data.event_details && data.event_details.length > 0) {
        data.event_details.forEach((item) => {
          const calendarItem = this.createCalendarItem(item);
          contentItems.appendChild(calendarItem);
      });
        this.bindRemoveEvents();
        this.bindDragEvents();
      } else {
        const emptyItem = this.createCalendarEmptyItem(data);
        contentItems.appendChild(emptyItem);
      }
    }

    renderCalendarError() {
      const contentItems = this.querySelector(".calendar-drawer__content-items");
      if (!contentItems) return;

      // Hide loader if present
      const loader = this.querySelector('.calendar-loader-container');
      if (loader) loader.style.display = 'none';

      contentItems.innerHTML = `
        <div class="calendar-drawer__empty">
          <p>Unable to load calendar. Please try again later.</p>
        </div>
      `;
    }
  
    createCalendarItem(itemData) {
      const date = new Date(itemData.date);
      const month = date.toLocaleString("default", { month: "long", year: "numeric" });
  
      const existingElement = document.querySelector(`.calendar-${month.replace(/\s+/g, '-')}`);
  
      const newItem = document.createElement("div");
      newItem.classList.add("calendar-item");
      newItem.setAttribute("draggable", "true");
      newItem.dataset.date = itemData.date;
      newItem.dataset.productId = itemData.product_id;
      newItem.dataset.eventDate = itemData.date;
  
      if (!existingElement) {
        newItem.innerHTML += `<h4 class="calendar-${month.replace(/\s+/g, '-')}">${month}</h4>`;
      }
  
      let itemName = itemData.name || itemData.title || '';
      itemName = itemName.replace(/- subscription/i, "").replace(/-/g, " ");

      const imageHtml = itemData.image_url
        ? `<img class="product-image-calendar" src="${itemData.image_url}" alt="${itemData.image_alt || itemName}">`
        : `<div class="calendar-drawer__item-image-placeholder"></div>`;

      const upchargeHtml = itemData.premium_value && itemData.premium_value > 0
        ? `<p class="calendar-upcharge">+ £${itemData.premium_value} UPCHARGE</p>`
        : "";

        newItem.innerHTML += `
        <div class="calendar-product-details">
          <div class="calendar-product-image">
            ${imageHtml}
          </div>
          <div class="calendar-product-title">
            <h5>${itemName}</h5>
            ${upchargeHtml}
          </div>
          <div class="calendar_remove" data-date="${itemData.date}" data-product-id="${itemData.product_id}" data-event-id="${itemData.product_id}">
            <img class="calendar_remove_icon" src="https://cdn.shopify.com/s/files/1/0831/2740/2829/files/snc_remove.webp?v=1727788305">
          </div>
        </div>
      `;
  
      return newItem;
    }
  
    createCalendarEmptyItem(customerData) {
      const item = document.createElement("div");
      item.className = "calendar-drawer__empty";

      const subscriptionStatus = customerData.subscription_status;
      const nextBillingDate = customerData.next_billing_date;

      let content = `
        <div class="calendar-drawer__empty-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
        </div>
        <h3 class="calendar-drawer__empty-title">Your Calendar is Empty</h3>
      `;

      if (subscriptionStatus === "active") {
        content += `
          <p class="calendar-drawer__empty-message">
            You don't have any upcoming scent deliveries scheduled.
          </p>
          <p class="calendar-drawer__empty-submessage">
            Browse our collection to add your first scent to your calendar!
          </p>
        `;
      } else {
        content += `
          <p class="calendar-drawer__empty-message">
            Start your scent journey by subscribing to our service.
          </p>
          <p class="calendar-drawer__empty-submessage">
            Choose from our curated collection and get regular deliveries.
          </p>
        `;
      }

      if (nextBillingDate) {
        const billingDate = new Date(nextBillingDate);
        const formattedBillingDate = billingDate.toLocaleDateString("en-US", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        content += `
          <div class="calendar-drawer__billing-info">
            <p class="calendar-drawer__billing-label">Next billing date:</p>
            <p class="calendar-drawer__billing-date">${formattedBillingDate}</p>
        </div>
      `;
      }

      item.innerHTML = content;
      return item;
    }
  
    bindRemoveEvents() {
      const removeButtons = this.querySelectorAll(".calendar_remove");
      removeButtons.forEach((button) => {
        button.addEventListener("click", (event) => this.handleRemoveClick(event));
      });
    }
  
    bindDragEvents() {
      const items = this.querySelectorAll(".calendar-item");
      items.forEach((el) => {
        el.addEventListener("dragstart", (event) => this.handleDragStart(event));
        el.addEventListener("dragover", (event) => this.handleDragOver(event));
        el.addEventListener("drop", (event) => this.handleDrop(event));
      });
    }
  
    async handleRemoveClick(event) {
      event.stopPropagation();
      
      // Get data from the remove button itself
      const removeBtn = event.currentTarget;
      const productId = removeBtn.dataset.productId;
      const eventDate = removeBtn.dataset.date;
      const item = removeBtn.closest(".calendar-item");
      
      console.log("🗑️ Remove clicked:", { productId, eventDate, customerId: window.customerId });
      
      if (!productId || !eventDate) {
        console.error("Missing productId or eventDate", { productId, eventDate });
        return;
      }
  
      try {
        const result = await fetchAppProxyData("remove_customer_product_from_calendar", {
        customerId: window.customerId,
          shopify_product_id: productId,
          event_date: eventDate,
          shop: window.shopUrl,
        });

        console.log("Remove result:", result);

        if (result && (result.status === "success" || result.success === true)) {
          console.log("✅ Event removed successfully - refreshing calendar");
          
          // Refresh calendar data to show backfilled events
          try {
            const customerId = window.customerId;
            const shop = window.shopUrl;
            if (customerId) {
              const data = await fetchAppProxyData("get_customer_data", {
                customerId: customerId,
                shop: shop,
              });
              console.log("✅ Calendar data refreshed after removal:", data);
              this.renderCalendarContent(data);
            } else {
              // Fallback: just remove the item if we can't refresh
              item.remove();
              const remainingItems = this.querySelectorAll(".calendar-item");
              if (remainingItems.length === 0) {
                this.renderCalendarContent({ event_details: [] });
              }
            }
          } catch (refreshError) {
            console.error("Error refreshing calendar after removal:", refreshError);
            // Fallback: just remove the item
            item.remove();
            const remainingItems = this.querySelectorAll(".calendar-item");
            if (remainingItems.length === 0) {
              this.renderCalendarContent({ event_details: [] });
            }
          }
        } else {
          console.error("Failed to remove event:", result);
        }
      } catch (error) {
        console.error("Error removing event:", error);
      }
    }
  
    handleDragStart(event) {
      const src = event.currentTarget;
      const payload = JSON.stringify({
        productId: src.dataset.productId,
        date: src.dataset.date || src.dataset.eventDate,
      });
      event.dataTransfer.setData("application/json", payload);
      src.classList.add("dragging");
    }
  
    handleDragOver(event) {
      event.preventDefault();
    }
  
    async handleDrop(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const srcData = JSON.parse(event.dataTransfer.getData("application/json"));
      const dstData = {
        productId: target.dataset.productId,
        date: target.dataset.date || target.dataset.eventDate,
      };
  
      // If same item, ignore
      if (srcData.productId === dstData.productId && srcData.date === dstData.date) {
        return;
      }

      try {
        const result = await fetchAppProxyData("change_customer_product_date", {
        customerId: window.customerId,
          dropProductId: dstData.productId,
          dropDate: dstData.date,
          dragProductId: srcData.productId,
          dragDate: srcData.date,
        });

        if (result && (result.status === "success" || result.success === true)) {
          console.log("✅ Reordered successfully");
          this.refreshCalendarData();
        } else {
          console.error("Failed to reorder:", result);
        }
      } catch (error) {
        console.error("Error reordering:", error);
    }
  }

  // WebSocket Methods for Real-Time Updates
  initializeWebSocket() {
    this.ws = null;
    this.wsReconnectInterval = null;
    this.wsReconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
  }

  connectWebSocket(customerId) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      return; // Already connected
    }

    try {
      // Get WebSocket URL from current page
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      const wsUrl = `${protocol}//${window.location.host}/ws/calendar/${customerId}/`;
      
      console.log('Attempting WebSocket connection:', wsUrl);
      
      this.ws = new WebSocket(wsUrl);
      
      this.ws.onopen = (event) => {
        console.log('✅ WebSocket connected - Real-time sync enabled');
        this.wsReconnectAttempts = 0;
        this.clearReconnectInterval();
      };
      
      this.ws.onmessage = (event) => {
        this.handleWebSocketMessage(event);
      };
      
      this.ws.onclose = (event) => {
        console.log('🔌 WebSocket disconnected - Falling back to standard mode');
        this.scheduleReconnect(customerId);
      };
      
      this.ws.onerror = (error) => {
        console.log('⚠️ WebSocket unavailable - Using standard calendar mode');
        // Don't schedule reconnect if server doesn't support WebSockets
        this.wsReconnectAttempts = this.maxReconnectAttempts;
      };
      
    } catch (error) {
      console.log('⚠️ WebSocket not supported - Using standard calendar mode');
      this.wsReconnectAttempts = this.maxReconnectAttempts;
    }
  }

  handleWebSocketMessage(event) {
    try {
      const data = JSON.parse(event.data);
      console.log('WebSocket message received:', data);
      
      switch (data.type) {
        case 'calendar_data':
          this.handleCalendarDataUpdate(data.data);
          break;
        case 'calendar_update':
          this.handleCalendarUpdate(data.data);
          break;
        case 'subscription_update':
          this.handleSubscriptionUpdate(data.data);
          break;
        case 'sync_result':
          this.handleSyncResult(data.data);
          break;
        case 'error':
          console.error('WebSocket error:', data.message);
          break;
        default:
          console.log('Unknown WebSocket message type:', data.type);
      }
    } catch (error) {
      console.error('Error parsing WebSocket message:', error);
    }
  }

  handleCalendarDataUpdate(data) {
    // Update calendar with fresh data from WebSocket
    console.log('Updating calendar with fresh data:', data);
    
    // Clear existing calendar content
    const contentItems = this.querySelectorAll('.calendar-drawer__content-items');
    contentItems.forEach((item) => (item.innerHTML = ''));
    
    if (data.event_details && data.event_details.length > 0) {
        data.event_details.forEach((item) => {
          const calendarItem = this.createCalendarItem(item);
          contentItems[0].appendChild(calendarItem);
        });
        this.bindRemoveEvents();
        this.bindDragEvents();
    } else {
        const emptyItem = this.createCalendarEmptyItem(data);
        contentItems[0].appendChild(emptyItem);
    }
  }

  handleCalendarUpdate(data) {
    console.log('Calendar update received:', data);
      // Refresh the calendar content
    this.refreshCalendarData();
  }

  handleSubscriptionUpdate(data) {
    console.log('Subscription update received:', data);
      // Update notification footer with new subscription info
    this.updateNotificationFooter(data);
  }

  updateNotificationFooter(subscriptionData) {
      const calendarFooterContent = this.querySelector('.calendar-drawer__footer-content');
    if (calendarFooterContent && subscriptionData.next_billing_date) {
        const billingDate = new Date(subscriptionData.next_billing_date);
        const formattedDate = billingDate.toLocaleDateString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      
        calendarFooterContent.innerHTML = `
          <p class="calendar-drawer__footer-text">
            Next billing: ${formattedDate}
          </p>
        `;
    }
  }

  refreshCalendarData() {
      // Trigger a refresh of calendar data
    if (window.customerId) {
        this.dispatchEvent(new CustomEvent('on:calendar-drawer:before-open'));
    }
  }

  showSyncFeedback(data) {
      const calendarFooterContent = this.querySelector('.calendar-drawer__footer-content');
    if (calendarFooterContent) {
        calendarFooterContent.innerHTML = `
          <p class="calendar-drawer__footer-text calendar-drawer__footer-text--success">
            ✅ ${data.message || 'Calendar synced successfully'}
          </p>
        `;
      
        // Clear the success message after 3 seconds
      setTimeout(() => {
          this.refreshCalendarData();
      }, 3000);
    }
  }

  scheduleReconnect(customerId) {
    if (this.wsReconnectAttempts >= this.maxReconnectAttempts) {
        console.log('Max reconnection attempts reached. WebSocket disabled.');
      return;
    }
    
    this.wsReconnectAttempts++;
      const delay = Math.min(1000 * Math.pow(2, this.wsReconnectAttempts), 30000);
    
      console.log(`Scheduling WebSocket reconnection attempt ${this.wsReconnectAttempts} in ${delay}ms`);
    
    this.wsReconnectInterval = setTimeout(() => {
      this.connectWebSocket(customerId);
    }, delay);
  }

  clearReconnectInterval() {
    if (this.wsReconnectInterval) {
      clearTimeout(this.wsReconnectInterval);
      this.wsReconnectInterval = null;
    }
  }

  disconnectWebSocket() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    this.clearReconnectInterval();
  }

  // Optional WebSocket connection - doesn't interfere with normal calendar operation
  loadInitialData() {
      // Calendar works normally regardless of WebSocket connection
      console.log('📅 Calendar drawer initialized');
      
    if (window.customerId && typeof WebSocket !== 'undefined') {
      // Use setTimeout to avoid blocking the main calendar initialization
      setTimeout(() => {
        this.connectWebSocket(window.customerId);
      }, 1000);
    }
    }
  }
  
  window.customElements.define("calendar-drawer", CalendarDrawer);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCalendarDrawer);
} else {
  initializeCalendarDrawer();
}